angular.module('gym.mobile_app').factory('MobileApp', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('mobile_app');
}]);
